import { ReactElement } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { colors } from "../../../ui/color"
import { ArrivalIcon } from "../../../ui/icons/arrivalsIcon"
import { DeparturesIcon } from "../../../ui/icons/departuresIcon"
import { HorizontalSecondaryTab } from "../../../ui/organisms/horizontalSecondaryTab"
import { Tab } from "../../../ui/organisms/tab"
import { setSelectedTabWeather } from "../slice"
import { ArrivalAirportWeather } from "./arrivalAirportWeather"
import { DepartureAirportWeather } from "./departureAirportWeather"
export function Weather() {
    const dispatch = useAppDispatch()

    const reportState = useAppSelector((state) => state.report)

    const viewAirportMap = new Map<number, ReactElement>([
        [0, <DepartureAirportWeather />],
        [1, <ArrivalAirportWeather />],
    ])

    return (
        <>
            <HorizontalSecondaryTab>
                <Tab
                    label={"Departure Airport"}
                    selectedSecondary={reportState.selectedTabWeather === 0}
                    onClick={() => dispatch(setSelectedTabWeather(0))}
                    type="secondary"
                    icon={<DeparturesIcon size={20} color={colors.neutral[700]} />}
                />
                <Tab
                    label={"Arrival Airport"}
                    selectedSecondary={reportState.selectedTabWeather === 1}
                    onClick={() => dispatch(setSelectedTabWeather(1))}
                    type="secondary"
                    icon={<ArrivalIcon size={20} color={colors.neutral[700]} />}

                />
            </HorizontalSecondaryTab>
            {viewAirportMap.get(reportState.selectedTabWeather)}
        </>
    )
}